import { Suspense } from 'react';
import { Outlet } from '@tanstack/react-router';

function RootFallback() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

export function RootLayout() {
  return (
    <Suspense fallback={<RootFallback />}>
      <Outlet />
    </Suspense>
  );
}
